import {GlobalVariables} from "../GlobalVariables";

export default class BlockPlaylistVideo {

    constructor() {
        this.blocks = document.querySelectorAll(".block-playlist-video");

        if (this.blocks.length > 0) {
            this.build();
            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    build() {
        this.blocks.forEach((block) => {
            const players = block.querySelector(".players");
            const playlist = block.querySelector(".playlist");

            if (playlist) {
                const swiper = new Swiper(playlist, {
                    slidesPerView: "auto",
                    freeMode: true,
                    grabCursor: true,
                    mousewheel: true,
                    breakpoints: {
                        768: {
                            direction: "vertical"
                        }
                    }
                });

                const playlistItem = playlist.querySelectorAll(".swiper-slide");
                const videos = players.querySelectorAll(".player-container");
                const titleEl = block.querySelector(".current-video-title");
                const transcriptions = block.querySelectorAll(".video-transcription");

                const activateVideo = (videoId) => {
                    videos.forEach((player) => {
                        const isActive = player.dataset.id === videoId;
                        player.classList.toggle("active", isActive);
                        const vc = player.querySelector(".video-player-container");
                        if (vc) vc.tabIndex = isActive ? 0 : -1;
                    });

                    transcriptions.forEach((details) => {
                        const isActive = details.dataset.id === videoId;
                        details.hidden = !isActive;
                        if (!isActive) details.open = false;
                    });

                    playlistItem.forEach((slide) => {
                        slide.setAttribute("aria-pressed", String(slide.dataset.id === videoId));
                    });

                    if (titleEl) {
                        const activeSlide = [...playlistItem].find(s => s.dataset.id === videoId);
                        if (activeSlide) {
                            titleEl.textContent = activeSlide.getAttribute("aria-label").replace("Lire la vidéo : ", "");
                        }
                    }
                };

                playlistItem.forEach((item) => {
                    item.addEventListener("click", () => activateVideo(item.dataset.id));
                    item.addEventListener("keydown", (e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            activateVideo(item.dataset.id);
                            const targetPlayer = [...videos].find(p => p.dataset.id === item.dataset.id);
                            if (targetPlayer) {
                                targetPlayer.querySelector(".video-player-container")?.click();
                            }
                        }
                    });
                });
            }
        });
    }
}
